import { HeatmapWSMessageType } from '../types/websocket';
import { useWSHeatmapBase } from './useWSHeatmapBase';

export const useWSHeatmapClicks = () => {
  return useWSHeatmapBase({
    dataType: 'clicks',
    wsMessageKey: HeatmapWSMessageType.CLICKS,
    cacheSelector: (state) => state.clicksCache,
    upsertSelector: (state) => state.upsertClicksCache,
    emptyData: [],
  });
};
